<template>
  <div v-loading="listLoading" class="tabList">
    <div v-show="propsObj.link" class="search-result">
      <div><span class="result-title">{{ wd | titleFilter }}</span> - 应用</div>
    </div>
    <div v-if="dataList && dataList.length>0" class="list">
      <div class="list-box">
        <div v-for="(item, index) in dataList" :key="index" class="list-item" @click="openWindow(item)">
          <div class="imgbox">
            <img v-if="item.appIconUrl !== null" :src="item.appIconUrl" class="imgsrc">
            <img v-else :src="require('@/assets/img/yingyong.png')" class="imgsrc">
          </div>
          <div class="text">
            <div class="title">
              {{ item.appName }}  <span class="right">
                <div class="add-btn" size="small" @click="handlerLink">添加应用</div>
              </span>
            </div>
            <p>
              <span v-for="(grade) in item.gradeList" :key="grade.code">
                {{ grade.name }}
              </span>
            </p>
            <p>
              <span v-for="(subject) in item.subjectList" :key="subject.code">
                {{ subject.name }}
              </span>
            </p>
            <p>{{ item.introduction }}</p>
            <p>下载次数：{{ item.downloads }} 次</p>
            <p class="">
              {{ item.createDate }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <global-empty
      v-else
      :label="`暂无数据~`"
      link-it="3"
      height="200"
    />
    <pagination
      v-show="propsObj.link"
      :total="searchForm.total"
      :page.sync="searchForm.pageNum"
      :limit.sync="searchForm.pageSize"
      @pagination="pageCurriculumList"
      @handleSizeChange="handleSizeChange"
    />
  </div>
</template>
<script>
import { getAppList } from '@/api/search';
import ENVIRONMENT from '@/utils/environment';

export default {
  name: 'TabList',
  props: {
    propsObj: {
      default: Object,
      type: Object
    },
    wd: {
      default: String,
      type: String
    },
    searchClick: {
      default: String,
      type: String
    }
  },
  data: () => {
    return {
      searchForm: {
        pageNum: 0,
        pageSize: 10,
        total: 0
      },
      link: '',
      dataList: [],
      height: '',
      listLoading: true
    };
  },
  watch: {
    searchClick(val) {
      console.log('点击app：' + val);
      this.getList();
    },
    $route() {
      this.getList();
    }
  },
  mounted() {
    console.log('app:' + this.wd);
    this.getList();
  },
  methods: {
    async getList() {
      this.listLoading = true;
      if (!this.propsObj.link) {
        this.searchForm.pageSize = 4; // 全部类型只查询四条
      }
      const params = {
        code: 'S01',
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        q: this.wd
      };
      await getAppList(params).then(res => {
        this.dataList = res.data.S01.list;
        this.searchForm.total = res.data.S01.total;
        setTimeout(() => {
          var list = document.getElementsByClassName('list-box');
          if (this.dataList.length < 1) {
            this.height = 150;
          } else if (list[0].offsetHeight) {
            this.height = list[0].offsetHeight;
          }
          const data = {
            result: this.searchForm.total,
            height: this.height
          };
          this.listLoading = false;
          window.parent.postMessage(data, '*');
        }, 500);
      });
    },
    openWindow(item) {
      window.open(ENVIRONMENT.appUrl + '/app-info.html?id=' + item.id);
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getList();
    },
    handlerLink() {
    // this.$router.push('/'+this.propsObj.link+'/'+this.propsObj.propsId);
    }
  }
};
</script>
<style scoped lang="scss">
.list{
  padding: 20px 0;
  .list-box{
    display: flex;
    flex-wrap: wrap;
    }
  .list-item {
    display: flex;
    justify-content: space-between;
    background: #F3FAFF;
    margin-bottom: 20px;
    flex-wrap: wrap;
    padding: 20px;
    width: 47.5%;
    margin-left: 20px;
    cursor: pointer;
    &:nth-child(even){
       padding-left: 40px;
    }
    &:nth-child(odd){
       padding-right: 30px;
    }
    .imgbox {
      width: 114px;
      height: 114px;
      .imgsrc {
        border-radius: 20px;
        width: 100%;
        height: 100%;
      }
    }
    .text {
      flex: 1;
      margin-left: 20px;
      line-height: 24px;
      p{
        width: 340px;
        height: 28px;
        line-height: 28px;
        overflow:hidden; //超出的文本隐藏
        text-overflow:ellipsis; //溢出用省略号显示
        white-space:nowrap; //溢出不换行
      }
      .title{
        font-size: 16px;
        font-weight: bold;
      }
      .date{
        font-size: 12px;
        color: #999;
      }
    }
  }
}
.search-result{
  display: flex;
  justify-content: space-between;
  padding: 20px 0 0 0;
  margin: 0 16px 0 20px;
  font-weight: bold;
  font-size: 18px;
  div{
    font-size: 18px;
    color: #787878;
    font-weight: 500;
  }
  .result-title{
  font-weight: bold !important;
  font-size: 18px !important;
  }
  span{
    color: #0082F1;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
}
.text > p {
  font-weight: 400;
  color: #787878;
  font-family: Microsoft YaHei;
}
.title{
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #007AFC;
}
.add-btn{
  width: 76px;
  height: 24px;
  background: #FFAE12;
  border-radius: 4px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  cursor: pointer;
}
</style>

